import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { LeverageProductType } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { LeverageProductsComponent } from '../../components/leverage-products/leverage-products.component';

@Component({
  templateUrl: './leverage-products-page.component.html',
  imports: [RouterLink, LeverageProductsComponent, TranslocoPipe],
})
export class LeverageProductsPageComponent implements OnInit {
  public name: string;
  public isin: string;
  public editLeverage = false;
  public investmentType: LeverageProductType = LeverageProductType.CALL;
  public readonly backLink = commonRoutes.postlogin.member_home;
  readonly #route = inject(ActivatedRoute);
  readonly #router = inject(Router);
  readonly #customerStateFacade = inject(CustomerStateFacade);

  constructor() {
    const { queryParamMap } = this.#route.snapshot;
    this.isin = queryParamMap.get('isin');
    this.name = queryParamMap.get('name');
    this.editLeverage = queryParamMap.get('editLeverage') === 'true';
    this.investmentType = queryParamMap.get('investmentType') as LeverageProductType;
  }

  public ngOnInit(): void {
    this.#customerStateFacade.loadCustomerBaseData();
    !this.isin || (!this.name && this.#router.navigate([commonRoutes.postlogin.member_home]));
  }
}
